import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {SalesOfficeMultiSelectComponent} from '../../components/DomainData/SalesOfficeMultiSelect.component';
import {FeatureDropdownComponent} from '../../components/DomainData/FeatureDropdown.component';
import {EmployeeEditComponent} from '../../components/Employees/EmployeeEdit.component';
import {ResetPasswordComponent} from '../../components/Employees/ResetPassword.component';
import {EmployeeFeaturesComponent} from '../../components/Employees/EmployeeFeatures.component';

@Component({
  selector: 'my-employees-grid',
  templateUrl: './EmployeesGrid.component.html'
})
export class EmployeesGridComponent implements OnInit {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(EmployeeEditComponent) employeeEditComponent: EmployeeEditComponent;
    @ViewChild(EmployeeFeaturesComponent) employeeFeaturesComponent: EmployeeFeaturesComponent;
    @ViewChild(ResetPasswordComponent) resetPasswordComponent: ResetPasswordComponent;
    @ViewChild(SalesOfficeMultiSelectComponent) salesOfficeMultiSelectComponent: SalesOfficeMultiSelectComponent;
    @ViewChild(FeatureDropdownComponent) featureDropdownComponent: FeatureDropdownComponent;

    userInfo: ent.UserInfo;
    employees: ent.Employee[];
    selectedEmployees: ent.Employee[] = [];
    editedEmployee: ent.Employee;
    allFeatures: ent.Feature[];
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private employeeService: serv.EmployeeService, private confirmationService: ConfirmationService,
         private router: Router) 
    {

    }

    ngOnInit(): void {
        
        this.editedEmployee = new ent.Employee();
        this.loadColumns();
        this.employeeEditComponent.salesOfficeDropdown.load();

        this.domainDataService.getFeatures().subscribe(x=>{this.allFeatures = x});
        this.userInfo = this.authenticationService.getUserInfo();
    }

    ngAfterViewInit() {
        this.featureDropdownComponent.load();
        this.salesOfficeMultiSelectComponent.load();
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Username', header: 'Username' },
            { field: 'FirstName', header: 'First Name' },
            { field: 'LastName', header: 'Last Name' },
            { field: 'FullName', header: 'FullName' },
            { field: 'SalesOffice.Name', header: 'Sales Office Name' },
            { field: 'PersonnelNumber', header: 'Personnel #' },
            { field: 'PhoneNumber', header: 'Phone #' },
            { field: 'EmailAddress', header: 'EmailAddress' },
            { field: 'Inactive', header: 'Inactive' },
        ];
    }

    onSearchClick(event: any){
        var filter: filters.EmployeeFilter = 
        {
            SalesOfficeIDs: this.salesOfficeMultiSelectComponent.selectedIDs,
            IncludeInactive: true
        };

        if (this.featureDropdownComponent.value > 0){
            filter.FeatureIDs = [];
            filter.FeatureIDs.push(this.featureDropdownComponent.value);
        }
        this.blockComponent.blocked = true;
        this.employeeService.getEmployees(filter).subscribe(x=>
            {
                this.employees = x;
                this.blockComponent.blocked = false;
            }, err =>
            {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            }
        );
        
    }

    onAddClick(event: any){
        this.editedEmployee = new ent.Employee();
        this.employeeEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, employee: ent.Employee){
        this.editedEmployee = employee;
        this.employeeEditComponent.salesOfficeDropdown.value = employee.SalesOfficeID;
        this.employeeEditComponent.setPasswordValidators();
        this.employeeEditComponent.displayDialog = true;
    }

    onEmployeeFeaturesClick(event: any, employee: ent.Employee){
        this.editedEmployee = employee;
        var filter: filters.EmployeeFilter = {EmployeeID: employee.ID};
        this.employeeService.getEmployees(filter).subscribe(x=>{
            if (x.length > 0){
                this.employeeFeaturesComponent.availableFeatures = [];
                this.employeeFeaturesComponent.selectedFeatures = [];
                var employee = x[0];
                if (employee.Features){
                    for (var feature of employee.Features){
                        this.employeeFeaturesComponent.selectedFeatures.push(feature);
                    }
                }
                for (var feature of this.allFeatures){
                    if (!employee.Features){
                        employee.Features = [];
                    }
                    if (employee.Features.filter(x=>x.ID == feature.ID).length == 0){
                        this.employeeFeaturesComponent.availableFeatures.push(feature);
                    }
                }
                this.employeeFeaturesComponent.displayDialog = true;
            }
        });
        
        
        
    }

    onEmployeeFeaturesOK(){
        this.blockComponent.blocked = true;
        var saveRequest: ent.EmployeeFeaturesSaveRequest = {EmployeeID: this.editedEmployee.ID, Features: this.employeeFeaturesComponent.selectedFeatures, SavedByEmployee: this.userInfo.Employee};
        this.employeeService.saveEmployeeFeatures(saveRequest).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        },
        err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
        
    }

    onEmployeeEditOK(){
        
        var request: ent.SaveEmployeeRequest = {Employee: this.editedEmployee, SavedByEmployee: this.userInfo.Employee};
        this.employeeService.saveEmployee(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
        
    }

    onResetPasswordClick(event: any, employee: ent.Employee){
        
        this.resetPasswordComponent.changePasswordComponent.changePassword = {EmployeeID: employee.ID, Username: employee.Username, RequireCurrentPassword: false, SavedByEmployee: this.userInfo.Employee};
        this.resetPasswordComponent.displayDialog = true;
    }
}